module.exports = __webpack_public_path__ + "static/media/MantaStyle.beb2114b.png";